import { render, staticRenderFns } from "./LotList.vue?vue&type=template&id=8b7f210e&scoped=true&"
import script from "./LotList.vue?vue&type=script&lang=js&"
export * from "./LotList.vue?vue&type=script&lang=js&"
import style0 from "./LotList.vue?vue&type=style&index=0&id=8b7f210e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7f210e",
  null
  
)

export default component.exports